import React, { useState, Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import {
  FiCheck, FiChevronDown
} from "react-icons/fi"
import { useQuery, useQueryClient, useQueries } from "@tanstack/react-query"
import { fetcher } from "../lib/api"

const EventsAPIListboxFilter = ({parkIdArray, defaultPark, api, selectedPark, setSelectedPark}) => {
  console.log('props', parkIdArray)

  const getParkNames = async key => {
    console.log("getParkNames key", key)
    const parkId = key.queryKey[1].id
    console.log("getParkNames parkId", parkId)

    if (parkId) {

      const res = await Promise.all(parkId.map(id => fetch(api, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          park_id: id,
        }),
      })))

      const jsons = await Promise.all(res.map(r => r.json()))
      console.log("parkNames jsons", jsons)

      return jsons
    }
  }

    //events API
    const { data, status } = useQuery(["names", { id: parkIdArray }], getParkNames)
  
    console.log("listbox data", data)

    //match id to name
    // if (status === "success") {
    //   const findPark = data?.find(x => x.park.id == selectedPark)
    //   console.log("find park name", findPark)
    //   const renderParkName = findPark.park.name
    // }

    const matchingName = (id) => {
      if (status === "success") {
        const findPark = data?.find(x => x.park.id == id)
        console.log("find park name", findPark)
        const renderParkName = findPark.park.name
        console.log("renderParkName", renderParkName)

        return renderParkName
      }
    }
    // const renderParkName = findPark.park.name
    


  return (
    <Listbox value={selectedPark} onChange={setSelectedPark} >
      <div className="relative mt-1">
        <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 text-sm">
          <span className="block truncate">Selected Park: {matchingName(selectedPark)}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <FiChevronDown
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {parkIdArray.map((park) => {
              return (
                <Listbox.Option 
                  key={park} 
                  value={park} 
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-amber-100 text-amber-900' : 'text-gray-900'}`
                }>
                  {({ selected }) => (
                    <>
                      <span
                        className={`block truncate ${
                          selected ? 'font-medium' : 'font-normal'
                        }`}
                      >
                        {matchingName(park)}
                      </span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                          <FiCheck className="h-5 w-5" aria-hidden="true" />
                        </span>
                      ) : null}
                    </>
                  )}
                  
                </Listbox.Option>
              )
            })}
          </Listbox.Options>
        </Transition>
      </div>
      
      
    </Listbox>
  )
}

export default EventsAPIListboxFilter